import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_PRIVACY = createActionTypes('FETCH_PRIVACY');
export const GET_PRIVACY = createActionTypes('GET_PRIVACY');
export const CREATE_PRIVACY = createActionTypes('CREATE_PRIVACY');
export const UPDATE_PRIVACY = createActionTypes('UPDATE_PRIVACY');
export const DELETE_PRIVACY = createActionTypes('DELETE_PRIVACY');
